import { defineStore } from 'pinia';
import { type Ref, ref } from 'vue';

export const useModalStore = defineStore('modalStore', () => {
    const imageTitle: Ref<string|null> = ref(null);
    const imagePaths: Ref<string[]> = ref([]);
    const showModal: Ref<boolean> = ref(false);
    const initialImageIndex: Ref<number> = ref(0);

    // Actions
    function setModalData(
        newImageTitle: string | null,
        newImagePaths: string[],
        setShowModal: boolean,
        setInitialImageIndex?: number
    ) {
        imageTitle.value = newImageTitle;
        imagePaths.value = newImagePaths;
        showModal.value = setShowModal;
        initialImageIndex.value = setInitialImageIndex || 0;
    }

    function resetModal() {
        imageTitle.value = null;
        imagePaths.value = [];
        showModal.value = false;
        initialImageIndex.value = 0;
    }

    return {
        imageTitle,
        imagePaths,
        showModal,
        initialImageIndex,
        setModalData,
        resetModal,
    };
});
